import React, { Component } from 'react'
import PropTypes from 'prop-types'

import InlineCss from 'react-inline-css'

const styles = `
  .dimmed.dimmable > .ui.animating.dimmer,
  .dimmed.dimmable > .ui.visible.dimmer,
  .ui.active.dimmer {
    background-color: rgb(0, 0, 0);
  }`

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'PreviewModalGenericContainer'

    static propTypes = {
      expanded: PropTypes.bool.isRequired,
      index: PropTypes.number.isRequired,
      lightBackground: PropTypes.bool,
      open: PropTypes.bool.isRequired,
      pictures: PropTypes.array.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      toggle: PropTypes.func.isRequired,
      toggleExpansion: PropTypes.func.isRequired,
    }

    static defaultProps = {
      lightBackground: false,
    }

    currentPicture = () => {
      const { index, pictures } = this.props

      if (index > -1) {
        const picture = pictures[index]

        return picture
      }

      return ''
    }

    handleClickLeft = () => {
      const { index } = this.props

      this.setCurrentIndex(index - 1)
    }

    handleClickRight = () => {
      const { index } = this.props

      this.setCurrentIndex(index + 1)
    }

    handleKeyDown = e => {
      if (e === 37) {
        if (this.previousPicture()) {
          this.handleClickLeft()
        }
      } else if (e === 39) {
        if (this.nextPicture()) {
          this.handleClickRight()
        }
      }
    }

    meta = () => {
      const { index, pictures } = this.props

      const picture = pictures[index]

      if (picture) {
        if (picture.meta) {
          return picture.meta
        }
      }
    }

    nextPicture = () => {
      const { index, pictures } = this.props

      if (index > -1) {
        const picture = pictures[index + 1]

        if (picture) {
          return true
        }
      }

      return false
    }

    previousPicture = () => {
      const { index, pictures } = this.props

      if (index > -1) {
        const picture = pictures[index - 1]

        if (picture) {
          return true
        }
      }

      return false
    }

    setCurrentIndex = index => {
      const { setCurrentIndex } = this.props

      setCurrentIndex(index)
    }

    render() {
      const { expanded, lightBackground, open, toggle, toggleExpansion } = this.props

      const currentPicture = this.currentPicture()
      const meta = this.meta()
      const next = this.nextPicture()
      const previous = this.previousPicture()

      return (
        <div>
          {expanded ? <InlineCss stylesheet={styles} /> : null}

          <WrappedComponent
            currentPicture={currentPicture}
            expanded={expanded}
            handleClickLeft={this.handleClickLeft}
            handleClickRight={this.handleClickRight}
            handleKeyDown={this.handleKeyDown}
            lightBackground={lightBackground}
            meta={meta}
            next={next}
            open={open}
            previous={previous}
            toggle={toggle}
            toggleExpansion={toggleExpansion}
          />
        </div>
      )
    }
  }

  return Container
}
